import React from 'react';
import {List, ListItem} from 'material-ui/List';
import TextField from 'material-ui/TextField';
import Delete from 'material-ui/svg-icons/action/delete';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import {CardActions} from 'material-ui/Card';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

const AnswerListItem = (props) => (
  <ListItem primaryText={props.title} onClick={props.onClick.bind(this, props.id)} rightIcon={<EditIcon />} />
)

class EditableAnswerList extends React.Component {

  constructor(props) {
    super()
    this.state = {
      answers: props.answers.slice()
    }
    this.onItemClick = this.onItemClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddAnswer = this.handleAddAnswer.bind(this);
  }

  render() {

    return (
      <div>
      <List>
        {
          this.state.answers.map((answer) => {
            return (
              <div key={answer.id}>
              <Divider />
              <AnswerListItem {...answer} onClick={this.onItemClick} />
              <Divider />
              </div>
            )
          })
        }
        { this.state.openAnswer ? <AnswerEditModal {...this.state.openAnswer} response={this.props.response} onClose={this.handleClose} onSubmit={this.handleSubmit} onDelete={this.handleDelete} {...this.props} /> : null }
      </List>
      {!this.props.isTranslation && <CardActions style={{textAlign: 'right'}}>
        <RaisedButton primary={true} onClick={this.handleAddAnswer} label="Add" />
      </CardActions>}
      </div>
    )
  }

  onItemClick(id) {
    this.setState({openAnswer: this.props.answers.find((a) => a.id === id)});
  }

  handleAddAnswer() {
    this.setState({
      openAnswer: {
        new: true,
        id: this.state.answers.reduce((max, a) => {
            if (a.id > max) {
              max = a.id;
            }
            return max
          }, 1) + 1,
        title: ""
      }
    });
  }

  handleClose() {
    this.setState({openAnswer: null});
  }

  handleSubmit(props) {
    if (props.new) {
      delete props.new;
      let answers = [
        ...this.state.answers,
        props
      ];
      this.setState({openAnswer: null, answers: answers});
      this.props.onUpdate(answers);
    } else {
      var index = this.state.answers.indexOf(this.state.openAnswer);
      let answers = [
        ...this.state.answers.slice(0, index),
        Object.assign({}, this.state.openAnswer, props),
        ...this.state.answers.slice(index + 1)
      ];
      this.setState({openAnswer: null, answers: answers});
      this.props.onUpdate(answers);
    }
  }

  handleDelete(id) {
    if (global.confirm("Are you sure? Any related criteria or caveats will be lost.")) {
      var index = this.state.answers.indexOf(this.state.openAnswer);
      let answers = [
        ...this.state.answers.slice(0, index),
        ...this.state.answers.slice(index + 1)
      ];
      this.setState({openAnswer: null, answers: answers});
      this.props.onUpdate(answers);
    }
  }

}

class AnswerEditModal extends React.Component {

  constructor(props) {
    super()
    this.state = {
      title: props.title || ""
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  render() {

    let actions = this.props.isTranslation ? [
      <FlatButton
        label="Cancel"
        primary={false}
        onClick={this.props.onClose}
      />,
      <RaisedButton
        label="Submit"
        primary={true}
        disabled={!this.state.title.length}
        onClick={this.handleSubmit}
      />
    ] : [
      <FlatButton
        label="Delete"
        secondary={true}
        onClick={this.props.onDelete}
        icon={<Delete color="red" />}
      />,
      <FlatButton
        label="Cancel"
        primary={false}
        onClick={this.props.onClose}
      />,
      <RaisedButton
        label="Submit"
        primary={true}
        disabled={!this.state.title.length}
        onClick={this.handleSubmit}
      />
    ];

    return (
      <Dialog
        title={this.props.new ? "Add New Answer" : "Edit Answer"}
        actions={this.props.new ? actions.slice(1) : actions}
        modal={true}
        open={true}
      >
        <TextField ref="answerText" id={"answerText" + this.props.id} defaultValue={this.state.title} onChange={this.handleTitleChange} onKeyDown={this.handleKeyDown} />
      </Dialog>
    );
  }

  handleSubmit() {
    this.props.onSubmit({
      title: this.state.title,
      id: this.props.id,
      new: this.props.new
    })
  }

  handleTitleChange(el, value) {
    this.setState({title: value});
  }

  handleKeyDown(e, v) {
    if (e.keyCode === 13) {
      this.setState({title: this.refs.answerText.getValue()});
      this.handleSubmit();
    }
  }
}

EditableAnswerList.defaultProps = {
  isTranslation:false
}

export default EditableAnswerList;
